export default __webpack_public_path__ + "static/media/g-xxl-1.af3df441.png";